import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operator/filter';
declare var $: any;

const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CATNAME === x.CATNAME) === idx);
const distinctSubCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.SUBCATNAME === x.SUBCATNAME) === idx);
const distinctPartType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PARTTYPENAME === x.PARTTYPENAME) === idx);
const distinctUOM = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.UOMTYPENAME === x.UOMTYPENAME) === idx);
@Component({
  selector: 'app-ts-maintenance',
  templateUrl: './ts-maintenance.component.html',
  styleUrls: ['./ts-maintenance.component.scss']
})
export class TsMaintenanceComponent {
  search: any;
  prjId: any;
  showLoader: boolean;
  TSMaintMasterList: any;
  vehMaintUOMList: any;
  priceModal: any;
  uomModal: any;
  serviceModal: any;
  partModal: any;
  quantityModal: any;
  upQuantityModal: any;
  saveSuccess = false;
  errorInSuccess = false;
  userId: any;
  respMsg: any;
  selectedRow: number;
  maintMstDataNotFound = false;
  vehiclesCatogeryList: any;
  vehiclesTypeList: any;
  vehCotegaryId: any;
  vehTypeId: any;
  partCode: any;
  imgLoaderPath: any;
  entityCodeLoaderDiv = false;
  isVehicleUpdtbtn = false;
  newPartCode: any;
  categoryList: any;
  subCategoryList: any;
  partTypeList: any;
  categoryId: any;
  partModalData: any;
  typeModal: any;
  categoryModal: any;
  subCategoryModal: any;
  newCategory: any;
  categoryCreateMsg: any;
  categorySuccess = false;
  categoryError = false;
  newSubCategory: any;
  subCatError = false;
  subCatSuccess = false;
  newPartTypeModal: any;
  partSuccess = false;
  partError = false;
  itemToUpdate: any;
  upCategoryModal: any;
  upTypeModal: any;
  upPartModal: any;
  upUomModal: any;
  upPriceModal: any;
  upSubCategoryModal: any;
  CATNAME: string;
  partCodeModal: any;
  syncing: any;
  public roleList: any;
  loaderClass: any;
  vTypeModel: any;
  vSubCategoryModal: any;
  vCategoryModal: any;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  newQuantityModal: any;
  newPriceModal: any;
  public wrongQuantity: boolean = false;
  vendorModal: any;
  invoiceModal: any;
  inwardModal: any;
  invoiceDateModal: any;
  clearBtn: boolean;
  assignBtn: boolean;
  entityCd: any;
  entityName: any;
  tsid: any;
  partList: Object;
  PartNumber: any;
  searchParts: string;
  Quantity: any;
  partQuantity: any;
  partRate: any;
  totalAmount: string;
  partID: any;
  partName: any;
  avlblQty: any;
  unitPrice: any;

  updatePartsObj: {};
  partObj = { partsArray: [] }
  partArray = []
  part_Array = []
  maintVehInfo = []
  blankAry = []
  sumVal: any;
  totalSum: any;
  extraCost: any;
  RepairCostRemarks: string;
  entityId: any;
  tsMaintenanceLog: any;
  materialPartList: any;
  actualQTY: any;
  hasRightQty: boolean = true;
  wrongQty: boolean = false;
  hasBiggerQty: boolean;
  grandTotal: any;
  partGrandTotal: any;
  TSMaintMasterLog: Object;

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  vUomModel: any;
  selectedCatID: any;
  selectedSubCatID: any;
  selectedUomID: any;
  selectedTypemID: any;
  oneCatID: any;
  oneSubCatID: any;
  oneUomID: any;
  oneTypeID: any;
  newSubCategoryList: any;

  private loadProducts(): void {
    this.gridData = process(this.TSMaintMasterList, { group: this.groups });
    this.gridData2 = process(this.tsMaintenanceLog, { group: this.groups });
  }
  public gridData: GridDataResult;
  public gridData2: GridDataResult;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    public router: Router
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
  }

	/*
   * Get TS List
  */

  getTSMasterList() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'maintenance/getTSMaster?prjId=' + this.prjId).subscribe((data) => {
      console.log(data,185);
      
      this.TSMaintMasterList = data;
      console.log('all data', this.TSMaintMasterList);
      if (this.TSMaintMasterList.length > 0) {
        this.gridData = process(this.TSMaintMasterList, this.state);
        this.maintMstDataNotFound = false;
        this.loaderService.display(false);
      } else {
        this.maintMstDataNotFound = true;
        this.loaderService.display(false);
        this.gridData = process(this.TSMaintMasterList, this.state);
      }
    });
  }

  /*
   * Get TS List
  */

  // getTSMasterLog() {
  //   this.loaderService.display(true);
  //   this.http.get(environment.apiUrl + 'maintenance/getTSLog?prjId=' + this.prjId).subscribe((data) => {
  //     this.TSMaintMasterLog = data;
  //     console.log('all data', this.TSMaintMasterLog);
  //   });
  //   $('#logModel').modal('show');
  // } 

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.TSMaintMasterList, this.state);
    if (state && state.group) {
      this.gridData = process(this.TSMaintMasterList, this.state);
    }
  }

  syncData() {
    this.syncing = true;
    this.loaderClass = 'fas fa-sync fa-spin';
    this.http.get(environment.apiUrl + 'maintenance/getTSMaster?prjid=' + this.prjId).subscribe((data) => {
      this.syncing = false;
      this.loaderClass = 'fas fa-sync';
      this.TSMaintMasterList();
    });
    console.log("Refresh")
  }

	/*
 * TS Part Assignment MOdel
 */
  assignmentModel(data) {
    console.log("Udtae data", data)
    $('#assignmentModel').modal('show');
    this.partArray = []
    this.partObj.partsArray = []
    this.assignBtn = false;
    this.clearBtn = true;
    this.entityCd = data.entityCd;
    this.entityId = data.entityId;
    this.entityName = data.entityName;
    this.tsid = data.id;
  }

  clearBtnEnable(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue) {
      this.clearBtn = false
    }
    if (filterValue.length == 0) {
      this.clearBtn = true
    }
  }

  getpartList() {
    this.http
      .get(environment.apiUrl + 'maintenance/searchPartMaster?prjId=' + this.prjId + '&search=' + this.searchParts)
      .subscribe((data) => {
        this.partList = data;
        this.PartNumber = this.partList[0].PARTID
        var partqty = this.partList[0].availableQuantity
        this.Quantity = partqty.toString();
        this.partQuantity = partqty
        var partrate = this.partList[0].UNITPRICE
        this.partRate = partrate.toString();
        var totalamt = partqty * partrate
        this.totalAmount = totalamt.toString()
      });
  }

  assignPart(data) {
    // this.clearAllFields();
    this.partID = data.PARTID
    this.partName = data.PARTNAME
    this.actualQTY = data.availableQuantity
    this.avlblQty = data.availableQuantity
    this.unitPrice = data.UNITPRICE
  }

  clearPartData() {
    this.partID = null
    this.partName = null
    this.avlblQty = null
    this.unitPrice = null
  }

  checkQtyLmt(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    const numQty = parseInt(filterValue, 10)
    if (numQty > this.actualQTY) {
      //   alert("The quantity has exceeded the available stock. Please change the quantity.")
      $("#qtyBox").css("border", "1px solid red");
      this.hasRightQty = false
      this.hasBiggerQty = true
      this.wrongQty = true
      //   return;
    }
    if (numQty <= this.actualQTY) {
      //   alert("The quantity has exceeded the available stock. Please change the quantity.")
      $("#qtyBox").css("border", "1px solid green");
      this.hasRightQty = true
      this.hasBiggerQty = false
      this.wrongQty = false
      //   return;
    }
  }

  returnFalse() {
    return false;
  }

  addPart() {
    var partid = parseInt(this.partID, 10)

    var partsObj = {
      "partId": partid,
      "partName": this.partName,
      "rate": this.unitPrice,
      "quantity": this.avlblQty,
      "amount": this.unitPrice * this.avlblQty
    }
    this.partArray.push(partsObj);

    this.sumVal = this.partArray
      .map(item => item.amount)
      .reduce((prev, curr) => prev + curr, 0);

    //to update the quantity in inventory
    this.updatePartsObj = {
      partId: partid,
      quantity: this.avlblQty
    }
    this.partObj.partsArray.push(this.updatePartsObj);
    this.totalSum = this.sumVal

    this.clearPartData()
  }

  removePart(data) {
    var removeIndex = this.partArray.map(function (item) {		// get index of object with partId
      return item.partId;
    })
      .indexOf(data.partId);

    // remove object
    this.partArray.splice(removeIndex, 1);    //for logbook

    this.partObj.partsArray.splice(removeIndex, 1);		//for part update api

    this.sumVal = this.partArray
      .map(item => item.amount)
      .reduce((prev, curr) => prev + curr, 0);

    this.totalSum = this.sumVal
  }

  addExtra() {
    // this.extraCostView = this.extraCost
    if (this.extraCost) {
      if (this.RepairCostRemarks == '' || this.RepairCostRemarks == null || this.RepairCostRemarks == undefined) {
        alert('Please fill the extra cost details in remarks box!');
        $("#extraBox").css("border", "2px solid red");
      }
    }
    if (this.sumVal) {
      this.totalSum = this.sumVal + this.extraCost
    }
    else {
      this.totalSum = this.extraCost
    }
    console.log("Test", this.partObj.partsArray.length)
  }

  clearExtra() {
    // this.extraCostView = 0
    this.totalSum = this.totalSum - this.extraCost
    this.extraCost = 0
  }

  saveMaintenanceMaster() {
    this.assignBtn = true
    var prjid = parseInt(this.prjId, 10)
    var entityid = parseInt(this.entityId, 10)
    var sum = parseInt(this.totalSum, 10)
    var userid = parseInt(this.userId, 10)
    var data = {
      "prjId": prjid,
      "entityId": entityid,
      "partArray": this.partArray,
      "totalAmount": sum ? sum : 0,
      "userId": userid
    };
    console.log("Part Data", data)
    this.http.post(environment.apiUrl + 'maintenance/createTSMaintenanceLog', data).subscribe(
      res => {
        var result: any;
        result = res;
        console.log("Error 400", result);
        // var resCode = result.status[0].RESPONSECODE;
        // if (result == "Success") {
        if (result.length > 0) {
          this.saveSuccess = true;
          // this.respMsg = result.status[1].RESPONSEMESSAGE;
          // this.newPartCode = result.status[2].IDRESPONSE;
          this.getTSMasterList();
          setTimeout(() => {
            this.saveSuccess = false;
            $('#vehMaintMasterModal').modal('hide');
            this.clearAllFields();
            this.assignBtn = false;
          }, 2000);
          this.loaderService.display(false);
        } else {
          this.saveSuccess = false;
          this.errorInSuccess = true;
          this.loaderService.display(false);
          this.assignBtn = false;
        }
        // Swal({
        //   type: 'success',
        //   title: 'Cool',
        //   text: 'Part Assignment Successful'
        // })
      },
      (error) => {
        this.loaderService.display(false);
        this.assignBtn = false;
        Swal({
          type: 'success',
          // title: 'Oops...',
          text: 'Part Assignment Successful'
        });
      }
    );

    // var arrayObj = { partsArray: [] }

    // if (this.partObj.partsArray.length > 0) {
    //   this.http.post(environment.apiUrl + 'maintenance/updatePartQuantity', this.partObj).subscribe((data) => {
    //     var result = data;
    //     console.log('Count', this.partObj);
    //   });
    // } else {
    //   this.http.post(environment.apiUrl + 'maintenance/updatePartQuantity', arrayObj).subscribe((data) => {
    //     var result = data;
    //     console.log('Count', arrayObj);
    //   });
    // }

    this.clearAllFields();
    $('#assignmentModel').modal('hide');
    this.assignBtn = false;
  }

  /*
   * Get TS Maintenance Log
  */

  getTsMaintenanceLog(data) {
    this.entityName = data.entityName
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'maintenance/TSPartMaintenanceLog?entityId=' + data.entityId).subscribe((data) => {
      this.tsMaintenanceLog = data;
      if (this.tsMaintenanceLog.length > 0) {
        this.gridData2 = process(this.tsMaintenanceLog, this.state);
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.gridData2 = process(this.tsMaintenanceLog, this.state);
      }
      console.log('logDate', this.tsMaintenanceLog);
      this.loaderService.display(false);

      this.grandTotal = this.tsMaintenanceLog
        .map(item => parseInt(item.totalAmount, 10))
        .reduce((prev, curr) => prev + curr, 0);

    });
    $('#tsMaintLogbook').modal('show');
  }

  partsModel(data) {
    if (data.json_part_array == null || data.json_part_array == "" || data.json_part_array == undefined) {
      alert("No Data")
    }
    else {
      this.materialPartList = JSON.parse(data.json_part_array)
      console.log("maintenance Data", this.materialPartList)
    }

    this.partGrandTotal = this.materialPartList
      .map(item => item.amount)
      .reduce((prev, curr) => prev + curr, 0);

    $('#partInfoModel').modal('show');
  }

  clearAllFields() {
    this.searchParts = null;
    this.partList = null;
    this.partName = null;
    this.avlblQty = null;
    this.partArray = [];
    this.extraCost = null;
    this.RepairCostRemarks = null;
    this.totalSum = null;
    this.sumVal = null;
  }

  selectRowIndex(data, index) {
    this.selectedRow = index;
  }

  downloadExcelFile(TSInfoData) {
    const ws_name = 'TSInfo';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(TSInfoData);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'TSInfo.xlsx');
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;
    this.getTSMasterList();
  }
}



// WEBPACK FOOTER //
// ./src/app/maintenance/TS/tsMaster/ts-maintenance.component.ts